export enum DialogValuesEnums {
  ok = 'OK'
}
